
var login = require('./pages/Login')
var register = require('./pages/Register')
var newScheduled = require('./pages/NewScheduled')
var newDelayed = require('./pages/NewDelayed')
var newDelayedPublic = require('./pages/NewDelayed')
var resetPassword = require('./pages/ResetPassword')
var payment = require('./pages/Payment')
var subscription = require('./pages/Subscription')
var profile = require('./pages/Profile')
var manage = require('./pages/Manage')
var message = require('./pages/Message')
var delay = require('./pages/Delay')
var attachment = require('./pages/Attachment')
var bcsuccess = require('./pages/BCSuccess')
var userpending = require('./pages/UserPending')
var cryptopaymentresult = require('./pages/CryptoPaymentResult')

var component = function (comp, auth) {
  return {
    component: comp,
    auth: auth || false
  }
}
// private, public, general
module.exports = {
  '/': component(manage, 'private'),
  '/app': component(manage, 'private'),
  '/app/login': component(login, 'public'),
  '/app/register': component(register, 'public'),
  '/app/newscheduled': component(newScheduled, 'public'),
  '/app/newdelayed': component(newDelayed, 'private'),
  '/app/newdelayedpub': component(newDelayedPublic, 'public'),
  '/app/reset/:token': component(resetPassword, 'public'),
  '/app/payment/:token': component(payment, 'public'),
  '/app/delay/:token': component(delay, 'general'),
  '/app/attachment/:token': component(attachment, 'general'),
  '/app/message/:id': component(message, 'private'),
  '/app/managed': component(manage, 'private'),
  '/app/sub': component(subscription, 'private'),
  '/app/profile': component(profile, 'private'),
  '/app/bcsuccess': component(bcsuccess, 'general'),
  '/app/userpending': component(userpending, 'private'),
  '/app/cryptopaymentresult': component(cryptopaymentresult, 'general')
}



// WEBPACK FOOTER //
// ./src/client/routes.js